import { Component, AfterContentInit, ContentChildren, QueryList, Output, EventEmitter } from '@angular/core';
import { TabComponent } from '../tab/tab.component';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements AfterContentInit  {
  @ContentChildren(TabComponent) tabs!: QueryList<TabComponent>;
  @Output() tabChanged = new EventEmitter<string>(); // Event to notify HomeComponent

  ngAfterContentInit() {
    // Ensure one tab is active by default
    const activeTabs = this.tabs.filter(tab => tab.active);
    if (activeTabs.length === 0 && this.tabs.first) {
      this.tabs.first.active = true;
    }

    // Subscribe to each tab’s selection event
    this.tabs.forEach(tab => {
      tab.selected.subscribe(() => this.selectTab(tab));
    });
  }

  selectTab(selectedTab: TabComponent) {
    this.tabs.forEach(tab => (tab.active = tab === selectedTab));
    this.tabChanged.emit(selectedTab.title); // Emit tab title to HomeComponent
  }
}
